import { render, staticRenderFns } from "./coste_fabricacion.vue?vue&type=template&id=b482eca0&"
import script from "./coste_fabricacion.vue?vue&type=script&lang=js&"
export * from "./coste_fabricacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports